import {TypeAutresInfosATTR} from './TypeAutresInfosATTR';
import {AvisInitialTypeLight} from './AvisInitialTypeLight';
import {DescriptionReduite} from './DescriptionReduite';
import {Procedure} from './Procedure';
import {Attribution} from './Attribution';
import {TypeCrJugement} from './TypeCrJugement';
export class AttributionFromMAPA {

	public avisInitial: AvisInitialTypeLight;

	public autresInformations: TypeAutresInfosATTR;

	public descriptionReduite: DescriptionReduite;

	public attribution: Attribution;

	public criteresAttribution: TypeCrJugement;

	public pasAvisInitial: string;

	public procedure: Procedure;

	public resultatAttribution: string;

	constructor() {
		 		this.avisInitial = new AvisInitialTypeLight();
		this.autresInformations = new TypeAutresInfosATTR();
		this.descriptionReduite = new DescriptionReduite();
		this.attribution = new Attribution();
		this.criteresAttribution = new TypeCrJugement();
		this.pasAvisInitial = '';
		this.procedure = new Procedure();
		this.resultatAttribution = '';

	}
}
